import { Rate } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { IHotel28355 } from "../../../common/types";
import { formatReadableAddress } from "../../../common/util/util";
import { useFirestoreCollection } from "../../../hooks/useFirestoreCollection";
import { fetchHotelImage94307FromFirestore } from "../../../firestore/firestoreService";
import { ImageGallery } from "..";
import { HotelFullInfoWrapper } from "./Hotel.style";
interface IProps {
  hotel: IHotel28355;
  hotelId: string;
}
export const HotelFullInfo: React.FC<IProps> = ({ hotel, hotelId }) => {
  const [images, setImages] = React.useState([]);
  const dispatch = useDispatch();
  useFirestoreCollection({
    query: () => fetchHotelImage94307FromFirestore(hotelId),
    data: setImages,
    deps: [dispatch, hotelId],
    local: true,
    shouldExecute: !!hotelId,
  });
  // eslint-disable-next-line no-console
  console.log(hotel, images);
  return (
    <HotelFullInfoWrapper>
      <div className="hotel-full-info-card">
        <div className="hotel-full-info-header">
          <div className="hotel-full-info-title">
            <h1 className="hotel-full-info-name">{hotel.name}</h1>
            <Rate disabled defaultValue={hotel.starRating} />
            <div className="hotel-full-info-location">
              {formatReadableAddress(hotel?.address)}
            </div>
          </div>
        </div>
        <div className="hotel-full-info-gallery">
          <ImageGallery
            images={hotel?.images || images || []}
            showThumbnails
            showPlayButton={false}
          />
        </div>
        <div
          className="hotel-full-info-description"
          dangerouslySetInnerHTML={{
            __html: hotel.descriptions || "",
          }}
        />
      </div>
    </HotelFullInfoWrapper>
  );
};
